import { render, staticRenderFns } from "./OrderSmsForm.vue?vue&type=template&id=e8d22956&scoped=true&"
import script from "./OrderSmsForm.vue?vue&type=script&lang=js&"
export * from "./OrderSmsForm.vue?vue&type=script&lang=js&"
import style0 from "./OrderSmsForm.vue?vue&type=style&index=0&id=e8d22956&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d22956",
  null
  
)

export default component.exports